import { PublicClientApplication } from "@azure/msal-browser";

let myMSALObj = null; 

const initializeMsal = async (clientId, tenantId) => {
  const msalConfig = {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: `${window.location.origin}/auth`,
      issuer: `https://login.microsoftonline.com/${tenantId}`,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  }

  myMSALObj = new PublicClientApplication(msalConfig); 
  await myMSALObj.initialize()
}

const LOGIN_REQUEST = {
    scopes: ["openid", "offline_access"]
};

const login = () => {
  return myMSALObj.loginPopup(LOGIN_REQUEST)
}

const signout = async (currentUser) => {
  const currentAccount = await myMSALObj.getAccountByHomeId(currentUser.azure.homeAccountId);
  return myMSALObj.logoutPopup({account: currentAccount})
}

export {
    LOGIN_REQUEST,
    initializeMsal,
    login,
    signout
};